var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedInIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "#EEFAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.63281 11.2767C9.63281 10.3693 10.3925 9.63281 11.3289 9.63281H30.8858C31.8226 9.63281 32.5819 10.3693 32.5819 11.2767V30.9383C32.5819 31.8459 31.8226 32.5819 30.8858 32.5819H11.3289C10.3926 32.5819 9.63281 31.846 9.63281 30.9385V11.2765V11.2767Z",
    fill: "#006699"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6065 28.8396V18.5078H13.1724V28.8396H16.6069H16.6065ZM14.8902 17.0975C16.0875 17.0975 16.8329 16.3041 16.8329 15.3126C16.8104 14.2986 16.0875 13.5273 14.9129 13.5273C13.7376 13.5273 12.97 14.2986 12.97 15.3125C12.97 16.304 13.7151 17.0974 14.8677 17.0974H14.8899L14.8902 17.0975ZM18.5073 28.8396H21.9412V23.0705C21.9412 22.7621 21.9636 22.4529 22.0543 22.2327C22.3025 21.6155 22.8675 20.9766 23.8164 20.9766C25.0587 20.9766 25.5559 21.9239 25.5559 23.313V28.8396H28.9897V22.9157C28.9897 19.7423 27.2958 18.2656 25.0364 18.2656C23.1841 18.2656 22.3706 19.3009 21.9186 20.0061H21.9415V18.5082H18.5075C18.5523 19.4774 18.5072 28.8399 18.5072 28.8399L18.5073 28.8396Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInIcon);
export default __webpack_public_path__ + "static/media/LinkedInIcon.94eecd96c18d021fca1a2418ed6b0a21.svg";
export { ForwardRef as ReactComponent };